'use client';

import { Input as AntdInput } from 'antd';
import classNames from 'classnames';
import { ChangeEventHandler, ComponentProps, FC, useCallback, useMemo, useState } from 'react';
import { Control, useController, UseControllerProps, useFormContext } from 'react-hook-form';
import styles from './../Input/style.module.scss';

interface CustomProps {
  /** Текст лейбла над полем ввода */
  label?: string;
  /** Флаг отображения ошибок валидации */
  showError?: boolean;
  name: string;
}

export type InputProps = UseControllerProps & ComponentProps<typeof AntdInput> & CustomProps;

/**
 * Компонент Input с интеграцией React Hook Form
 */
const InputRHF: FC<InputProps> = ({
  label,
  showError = true,
  name,
  control,
  defaultValue,
  rules,
  shouldUnregister,
  ...props
}) => {
  const formContext = useFormContext();

  const {
    field,
    fieldState: { error, isTouched },
  } = useController({
    name,
    defaultValue,
    rules,
    shouldUnregister,
    control: control ?? formContext.control,

    // rules: validationRules,
  });

  const [value, setValue] = useState(String(field.value));

  const hasError = useMemo(() => {
    return showError && isTouched && !!error;
  }, [showError, isTouched, error]);

  return (
    <div className={styles.container}>
      {label && <label className={styles.label}>{label}</label>}
      <AntdInput
        className={classNames(styles.input, props.className)}
        status={hasError ? 'error' : undefined}
        data-key={'input_' + name}
        value={value}
        onChange={(e) => {
          field.onChange(e.target.value); // send data to hook form
          setValue(e.target.value);
        }}
        {...field}
        {...props}
      />
      {hasError && <label className={styles.errorLabel}>{error?.message}</label>}
    </div>
  );
};

export default InputRHF;
